export default __webpack_public_path__ + "static/media/cross-dark.4154bc16.svg";